/* Component for single product tile displayed on the basket  */
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import Srcset from "@/components/common/Srcset";
import styles from "../ProductTile.module.scss";
import stylesBasket from "../../Basket.module.scss";
import TileImage from "./TileImage";
import ErrorComp from "@/components/common/ErrorComp";
import { addToCart, openMiniCart } from "../../../../redux/actions/addToCartAction";
import { getVariantPrice, isGiftCardType, isDonationProduct } from "@/helpers/pdpHelpers/priceHelpers";
import { setCookie, hasCookie, getCookie, deleteCookie } from "cookies-next";

import {
  removeProductFromCart,
  updateProductInCart,
} from "@/helpers/cartHelpers";

import { errorMessages, generalConstants } from "@/utils/constants";
import { KlaviyoUserRemoveFromCart } from "@/components/common/Klaviyo";
import AddToWishlist from "@/components/common/AddToWishlist";
import FavouriteIcon from "@/components/common/FavouriteIcon";
import { openAccountSidebar, passMsgToAccountSidebar } from "@/redux/actions/loggedInUser";
import { setCart } from "@/components/common/Nosto";
import Tooltip from "@/components/common/Tooltip";
import { priceFormatFunc } from "@/helpers/stringFormat";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import CustomizationTag from "@/components/common/CustomizationTag";
import {getBaseColor, isBeautyOrJewelryPDP } from "@/helpers/generalHelper";

export default function ProductTile({ productInfo, isMobile, isFullBasket }) {
  const [showQuantityError, setshowQuantityError] = useState(false);
  const userId = useSelector((state) => state.loginUser.userData?.id);
  const wishlistHash = useSelector((state) => state.wishlist.wishlistHashId);
  const [outOfStockMessage, setoutOfStockMessage] = useState(false);
  const [specialEventFlag, setSpecialEventFlag] = useState(false);
  const [estimatedDeliveryFlag, setEstimatedDeliveryFlag] = useState(false);
  // Reusing getVariantPrice function used in the PDP
  let { returnedPrice, returnedSalePrice } = getVariantPrice(
    productInfo?.merchandise
  );
  let donationProduct = isDonationProduct(productInfo?.merchandise?.product);
  let giftcardType = isGiftCardType(productInfo?.merchandise);
  const price = returnedPrice;
  const salePrice = returnedSalePrice;
  const timeout = useRef(null);
  let selectedColor = null;
  let selectedSize = null;
  let selectedLetter = null;
  let badge_curated = null;
  productInfo?.attributes?.forEach((option) => {
    if (option?.key?.toLowerCase() === "_badge_curated") {
      badge_curated = option?.value || null;
    }
  });
  const [loading, setLoading] = useState(false);
  
  const deliveryDateRange = productInfo.attributes.find(i => i?.key === "_estimate")?.value;
  const today = new Date().toLocaleString('en-US', {month: 'short', day: 'numeric'});
  const todayFormatted = new Date(today + ", " + new Date().getFullYear());

  let endDate;
  let eventCutOffDate;
  let eventStartDate;
  let christmasCutOffDate;
  let christmasStartDate;
  if (isFullBasket && deliveryDateRange) {
    // Split the delivery date range into parts
    const parts = deliveryDateRange.split(" - ");
    const endDateString = parts[1].split(", ")[1];
    endDate = new Date(endDateString + ", " + new Date().getFullYear());

    const eventCutOffDateString = generalConstants.special_event_end_date;
    eventCutOffDate = new Date(eventCutOffDateString + ", " + new Date().getFullYear());

    const eventStartDateString = generalConstants.special_event_start_date;
    eventStartDate = new Date(eventStartDateString + ", " + new Date().getFullYear());

    //SUP-3657 Chhristmas cutoff banner need sto show only when current date falls between Nov 1st to Dec 24th
    //Estimated end date should fall between Dec 16 to Dec 24 
    const christmasCutOffDateString = generalConstants.christas_cutoff_end_date;
    christmasCutOffDate = new Date(christmasCutOffDateString + ", " + new Date().getFullYear());

    const christmasStartDateString = generalConstants.christas_cutoff_start_date;
    christmasStartDate = new Date(christmasStartDateString + ", " + new Date().getFullYear());
  }

  function calculateSpecialEventDate() {
    if (todayFormatted >= eventStartDate && todayFormatted <= eventCutOffDate) {
      if(christmasCutOffDate>=endDate && endDate>christmasStartDate){
        setSpecialEventFlag('special_style');
        setEstimatedDeliveryFlag('estimated_special_event');
      }else{
        setEstimatedDeliveryFlag('non_estimated_special_event')
      }
    } else {
      setSpecialEventFlag('default_style');
    }
  }
 // condition for identifying product type beauty or jewelry
 const isBeautyOrJewelryCategory = isBeautyOrJewelryPDP(productInfo?.merchandise?.product?.tags)

  productInfo?.merchandise?.selectedOptions.forEach((selectedOption) => {
    if (selectedOption.name.toLowerCase() === "color") {
      if (selectedOption.value !== "No Color")
        //For beauty & jewelry product show option color
        if(isBeautyOrJewelryCategory) {
          selectedColor = selectedOption.value;
        }else{
          // For other product show basecolor
          selectedColor= getBaseColor(productInfo?.merchandise?.baseColor?.value)
        }
    } else if (selectedOption.name.toLowerCase() === "size" || selectedOption.name.toLowerCase() === "denominations")
      selectedSize = selectedOption.value;
    else if (selectedOption.name.toLowerCase() === "style")
      selectedLetter = selectedOption.value;
  });

  // Setting the element to be displayed for color and Size and other options if any
  let optionsDisplay = null;
  if(donationProduct){
    optionsDisplay = (
      <span className={`xx-small-xs xx-small-sm x-small-md ${styles.options} ${styles.updateCursor}`}>
        {productInfo?.merchandise?.title}
      </span>
    );
  }
  else {
  if (selectedColor && selectedSize) {
    optionsDisplay = (
      <span className={`xx-small-xs xx-small-sm x-small-md ${styles.options}`}>
        {selectedColor} | {selectedSize}
      </span>
    );
  } else if (selectedLetter && selectedSize) {
    optionsDisplay = (
      <span className={`xx-small-xs xx-small-sm x-small-md ${styles.options}`}>
        {selectedLetter} | {selectedSize}
      </span>
    );
  } else if (selectedColor || selectedSize || selectedLetter) {
    optionsDisplay = (
      <span className={`xx-small-xs xx-small-sm x-small-md ${styles.options}`}>
        {selectedColor || selectedSize || selectedLetter}
      </span>
    );
  }
}

  const [quantityLimit, setQuantityLimit] = useState(false);
  const [undoMessage, setUndoMessage] = useState(false);
  const [fireWishList, setFireWishList] = useState(false);
  const dispatch = useDispatch();
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const handleClick = (e) => {
    if(isPWA) {
      dispatch(showPwaLoader(true))
    }
  }
  useEffect(() => {
    if(!giftcardType || !donationProduct){
      if (productInfo.quantity == productInfo?.merchandise?.quantityAvailable) {
        setQuantityLimit(true);
      }
      else {
        setQuantityLimit(false);
      }
    }
  })
  const updateQuantity = async (action) => {
    // Save the current focus
    const previouslyFocusedElement = document.activeElement;
    setLoading(true);

    let request = {};
    let response;
    let quantity;
    if (action == "Decrement") {
      quantity = parseInt(productInfo.quantity - 1);
      setshowQuantityError(false);
    } else {
      //increment
      if (giftcardType || donationProduct) {
        quantity = parseInt(productInfo.quantity + 1);
      } else if (productInfo.quantity < productInfo?.merchandise?.quantityAvailable) {
        quantity = parseInt(productInfo.quantity + 1);
      }
    }
    request.lineItems = [
      {
        id: productInfo.id,
        merchandiseId: productInfo?.merchandise?.id,
        quantity: quantity,
        attributes: productInfo.attributes
      },
    ];
    response = await updateProductInCart(request);
    await setCart(response);
    dispatch(addToCart(response));

    setLoading(false);
    // Restore the focus to the previously focused element
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }
  };
  useEffect(() => {
    //to calculate the range for the special delivery event
    isFullBasket && calculateSpecialEventDate();

    if (undoMessage) {
      //  if undoMessage is changed to false then remove product after 3 seconds,
      //  allow user to undo removal withing these 3 seconds
      timeout.current = setTimeout(
        () => {
          setFireWishList(true)
        },
        3000
      );
    }
    return () => {
      /* If user unClick the fake button then this runs */
      setFireWishList(false);
      clearTimeout(timeout.current);
    };
  }, [undoMessage]);
  const removeItem = async () => {
    setLoading(true);

    let lineItemId = [productInfo.id];
    let request = {
      lineItemIds: lineItemId,
    };
    let response = await removeProductFromCart(request);
    dispatch(addToCart(response));
    await setCart(response);
    setLoading(false);
    return response;
  };

  const [removeProduct, setRemoveProduct] = useState(false);
  let logUser = useSelector((state) => state.loginUser);

  //Move from bag to wishlist when user is not signed in 
  const moveToWishlist = () => {
    if (hasCookie("isFavouriteBag")) {
      let cookie_data = JSON.parse(getCookie("isFavouriteBag"));
      if (productInfo.merchandise.id === cookie_data.product.merchandise.id) {
        if (cookie_data.value === true && userId && wishlistHash) {
          //conditions added devices so that it run only once per device and undo message is displayed
          if (isMobile) {
            deleteCookie("isFavouriteBag");
            dispatch(openMiniCart(true));
            setUndoMessage(!undoMessage);
          }
          else {
            if (window.innerWidth > 1024) {
              deleteCookie("isFavouriteBag");
              dispatch(openMiniCart(true));
              setUndoMessage(!undoMessage);
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    if (productInfo?.merchandise?.quantityAvailable == 0) {
      setoutOfStockMessage(true);
    } else {
      setoutOfStockMessage(false);
    }
    moveToWishlist();
  });

  useEffect(() => {
    if (removeProduct) {
      setRemoveProduct(false);
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: [
            {
              item_brand: productInfo?.merchandise?.product?.vendor,
              item_id: productInfo?.parent_id,
              item_name: productInfo?.title,
              price: productInfo?.merchandise?.priceV2?.amount,
              quantity: productInfo?.quantity,
            },
          ],
        },
        //  'eventCallback': function() {
        //    document.location = `/products`
        //  }
      });
      KlaviyoUserRemoveFromCart(productInfo, logUser?.userData?.email)
    }
  }, [removeProduct]);
  const fakeFavoriteClick = () => {
    setUndoMessage(!undoMessage);
    moveToWishlist();
  }

  let engraving_text=productInfo?.attributes?.find(attr => attr?.key === "Free engraving")?.value;
  let engraving_cost=productInfo?.attributes?.find(attr => attr?.key === "_engraving_olivela_cost")?.value;
  
  return (
    // if its minibag and not full bag, then add margin bottom of 2rem to the tile
    <div className={`${!isFullBasket && "mb-20"}`}> 
      <div
        className={`row border ${productInfo.attributes.find(i => i?.key === "_estimate") ? `${styles.mb_0}` : `` } ${styles.product_tile} ${stylesBasket.product_tile} ${loading ? "loading" : ""}`}
      >
        <div className={styles.image}>
          <TileImage url={productInfo?.merchandise?.image?.src}
            href={donationProduct ? null : `/products/${productInfo?.merchandise?.product.handle}`}
            badge_curated={isFullBasket && badge_curated} 
            donationProduct={donationProduct}/>
          {!donationProduct && isFullBasket && <div className="favorite" tabIndex="0" onClick={fakeFavoriteClick}>
            {/* Fake Wishlist button */}
            {<FavouriteIcon
              isFilled={undoMessage}
              height={20}
              width={20}
            />}
          </div>}
        </div>
        {fireWishList && !undoMessage ? <>
          <div className="d-none"> <AddToWishlist
            selectedVariant={productInfo.merchandise}
            product={productInfo.merchandise.product}
            favouriteIconHeight={20}
            favouriteIconWidth={20}
            autoAdd={true}
            isSizeSelected={true}
            wishListCallBack={removeItem}
            setFireWishList={setFireWishList}
          /> </div>
        </> : null}
        {undoMessage ? <>
          {/* This show when user clicks on the fake wishlist button */}
          <div className={styles.card_msg}>
            <span className="small-md x-small-sm x-small-xs">This item has been moved to wishlist</span>
            <div className={styles.btn_wrapper}>
              <p className="cursor-pointer x-small-md xx-small-sm xx-small-xs" onClick={() => setUndoMessage(false)}>Undo</p>
            </div>
          </div>
          {fireWishList && <div className="d-none"> <AddToWishlist
            selectedVariant={productInfo.merchandise}
            product={productInfo.merchandise.product}
            favouriteIconHeight={20}
            favouriteIconWidth={20}
            autoAdd={undoMessage}
            isSizeSelected={true}
            wishListCallBack={removeItem}
          /> </div>}
        </>
          :
          <>
            {/* Default view of the card */}
            <div className={styles.details}>
              <p className={`small ${styles.product_title}`}>
              <a tabIndex={0} className={donationProduct ? `${styles.updateCursor}` : ""}
                href={donationProduct ? null : `/products/${productInfo?.merchandise?.product.handle}`} onClick={(e) => handleClick(e)}>
                  {productInfo?.merchandise?.product.vendor}
                </a>
              </p>
              <p className={`x-small ${styles.sub_text}`}>
                <a tabIndex={-1} className={donationProduct ? `${styles.updateCursor}` : ""}
                  href={donationProduct ? null : `/products/${productInfo?.merchandise?.product.handle}`} onClick={(e) => handleClick(e)}>
                  <Tooltip text={productInfo?.merchandise?.product?.title}/>
                </a>
              </p>
              {optionsDisplay}
              {productInfo?.merchandise?.product?.tags?.includes(
                "Final sale"
              ) && <p className={`x-small-md xx-small-xs xx-small-sm ${styles.final_sale}`}>Final sale</p>}
            </div>
            <div className={`text-end ${styles.sub_details}`}>
              <div
                className={`${styles.close_wrapper}`}
                role="button"
                onClick={() => {
                  removeItem();
                  setRemoveProduct(true);
                }}
              >
                <Srcset
                  requirePath={true}
                  svgFile={true}
                  src={"images/Icons/Cross/Large.svg"}
                  alt="cross-button"
                  height="12"
                  width="12"
                  layout=""
                  tabIndex={0}
                />
              </div>

              {!donationProduct && <div
                className={`${styles.quantity} ${stylesBasket.quantity} ${showQuantityError ? "input-error" : "border"
                  } text-center`}
              >
                <button tabIndex={0}
                  className={styles.minus}
                  onClick={() => {
                    updateQuantity("Decrement");
                    setRemoveProduct(true);
                  }}
                >
                  <Srcset
                    requirePath={true}
                    svgFile={true}
                    src={"images/Icons/Minus.svg"}
                    alt="minus"
                    height={6}
                    width={6}
                  />
                </button>
                <span className="x-small"> {(outOfStockMessage && !donationProduct && !giftcardType) ? '00' : productInfo.quantity.toString().padStart(2, "0")}</span>
                <button tabIndex={0} role="button" onClick={() => updateQuantity("Increment")} className={quantityLimit ? "disabled" : ""}>
                  <Srcset
                    requirePath={true}
                    svgFile={true}
                    src={"images/Icons/Plus/large.svg"}
                    alt="Plus"
                    height={6}
                    width={6}
                    className={styles.plus}
                  />
                </button>
              </div>}
              {!donationProduct && <div className="price-wrapper">
                {salePrice ? (
                  <>
                    <div className={`${styles.salePrice} ${stylesBasket.sale_price} sale_price x-small medium`}>
                    <span className={`text-red`}>{priceFormatFunc(salePrice)}</span>
                    </div>
                    <div className={`x-small medium ${styles.cancelledPrice}`}>
                      <span id="productCancelledPrice">
                      <s>{price}</s>
                      </span>
                    </div>
                  </>
                ) : (
                  <div className={`${styles.price} ${stylesBasket.price}`}>
                    <span className="x-small medium">{priceFormatFunc(price)}</span>
                  </div>
                )}
              </div>}
            </div>
          </>
        }
      </div>
      
      {/* Customization tag added when Engraving is added to product */}
      {engraving_text && (
      <CustomizationTag text={engraving_text} cost={engraving_cost} />)}
      {isFullBasket && productInfo.attributes.find(i => i?.key === "_estimate") && 
       (<div className={`${styles.estimated_delivery}  ${estimatedDeliveryFlag} ${specialEventFlag} xx-small-sm xxx-small-xs xx-small-md`}
        style={{ backgroundColor:  (estimatedDeliveryFlag == 'estimated_special_event' && specialEventFlag == 'special_style') ? generalConstants.special_event_color : ``, color: (estimatedDeliveryFlag == 'estimated_special_event' && specialEventFlag == 'special_style') ? generalConstants.special_event_txt_color : `` }} >
          {productInfo.attributes.find(i => i?.key === "_estimate")?.value}
        </div>)}
      {!giftcardType && showQuantityError && (
        <div className={`${styles.error}`}>
          <ErrorComp message={errorMessages.basket.limitedQuantity} />
        </div>
      )}
      {!giftcardType && !donationProduct && outOfStockMessage && (
        <div className={`${styles.error}`}>
          <ErrorComp message={errorMessages.basket.outOfStock} />
        </div>
      )}
    </div>
  );
}

